import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import Autosuggest from 'react-autosuggest';

import Loader from 'Component/Loader';
import { CompanySearchType } from 'Type/Account.type';

import './MyAccountCompanyAutosuggest.style';

/** @namespace PeggysagePwa/Component/MyAccountCompanyAutosuggest/Component */
export class MyAccountCompanyAutosuggestComponent extends PureComponent {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        suggestions: PropTypes.arrayOf(CompanySearchType).isRequired,
        onSuggestionsFetchRequested: PropTypes.func.isRequired,
        onSuggestionsClearRequested: PropTypes.func.isRequired,
        onSuggestionSelected: PropTypes.func.isRequired,
        getSuggestionValue: PropTypes.func.isRequired,
        value: PropTypes.string.isRequired,
        isLoading: PropTypes.bool.isRequired,
        isLoadingSuggestions: PropTypes.bool.isRequired
    };

    renderSuggestion(suggestion) {
        const {
            name, ape, apetexte, postcode, city
        } = suggestion;

        return (
            <div block="MyAccountCompanyAutosuggest" elem="Suggestion">
                <h5 block="MyAccountCompanyAutosuggest" elem="SuggestionName">
                    { name }
                </h5>
                <div block="MyAccountCompanyAutosuggest" elem="SuggestionApe">
                    { `${ape} - ${apetexte}` }
                </div>
                <div block="MyAccountCompanyAutosuggest" elem="SuggestionLocation">
                    { `${postcode} - ${city}` }
                </div>
            </div>
        );
    }

    render() {
        const {
            onChange,
            suggestions,
            onSuggestionsFetchRequested,
            onSuggestionsClearRequested,
            onSuggestionSelected,
            getSuggestionValue,
            value,
            isLoading,
            isLoadingSuggestions
        } = this.props;

        // Autosuggest will pass through all these props to the input.
        const inputProps = {
            label: __('Company name'),
            placeholder: __('Company name'),
            value,
            onChange
        };

        return (
            <>
                <div block="MyAccountCompanyAutosuggest">
                    <Autosuggest
                      suggestions={ suggestions }
                      onSuggestionsFetchRequested={ onSuggestionsFetchRequested }
                      onSuggestionsClearRequested={ onSuggestionsClearRequested }
                      onSuggestionSelected={ onSuggestionSelected }
                      getSuggestionValue={ getSuggestionValue }
                      renderSuggestion={ this.renderSuggestion }
                      inputProps={ inputProps }
                      focusInputOnSuggestionClick={ false }
                    />
                    <Loader isLoading={ isLoadingSuggestions } />
                </div>
                <Loader isLoading={ isLoading } />
            </>
        );
    }
}

export default MyAccountCompanyAutosuggestComponent;
